<template>
  <div v-if="show" class="d-in-block">
    <yxtf-button plain :loading="prevLoading" @click="handlePrevClick">{{ $t('pc_biz_o2o_btn_before_task') }}</yxtf-button>
    <yxtf-button type="primary" :loading="nextLoading" @click="handleNextClick">{{ $t('pc_biz_o2o_btn_next_task') }}</yxtf-button>
  </div>
</template>

<script>
import { precheckTask, checkTaskOnlyOne } from './service';
import { skipTask } from './skip';

export default {
  name: 'YxtbizSkipTask',
  props: {
    asyncTip: { // 考试和知识, 是否学完标志 true:学完 false:未学完
      type: Boolean,
      default: true
    },
    bizData: { // 包含 taskId、projectId、gwnlUrl（人才发展url,可以是空） 且为 string
      required: true,
      type: Object
      // validator: (value) => typeof value.taskId === 'string' && typeof value.projectId === 'string'
    }
  },
  data() {
    return {
      show: false,
      nextLoading: false,
      prevLoading: false
    };
  },
  watch: {
    bizData: {
      handler(val) {
        val.projectId && checkTaskOnlyOne(val.projectId).then(d => {
          this.show = d.data;
        });
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 1. 不能跳转提示
     * 2. 正常跳转，走相应的策略
     * 3. 考试，知识 异步提示： 正在跳转中，前端需要处理
     * @param {Number} type Prev or Next
     * @returns
     */
    precheckTask(type) {
      const { taskId, projectId, gwnlUrl } = this.bizData;
      return precheckTask({taskId, projectId, type}).then(({ result, code, errorMsg, datas}) => {
        if (!result) {
          if (code !== 'apis.o2o.taskcheck.task.skip') {
            return this.$message.info(errorMsg); // 不能跳转提示
          } else if (!this.asyncTip) {
            return this.$message.info(this.$t('pc_biz_o2o_tip_task_not_complete')); // 考试结果异步 正在跳转中
          }
        }
        skipTask({...datas, code, result, projectId, gwnlUrl}, this);
      });
    },
    handlePrevClick() {
      if (this.prevLoading) return;
      this.prevLoading = true;
      this.precheckTask(0).finally(() => {
        this.prevLoading = false;
      });
    },
    handleNextClick() {
      if (this.nextLoading) return;
      this.nextLoading = true;
      this.precheckTask(1).finally(() => {
        this.nextLoading = false;
      });
    }
  }
};
</script>
